import { AppError, AppErrorCode } from './AppError';

/**
 * Error thrown when Word API calls fail.
 */
export class WordApiError extends AppError {
  /** The operation being performed when the error occurred */
  public readonly operation: string;

  /**
   * Create a WordApiError
   * @param message user-friendly message
   * @param operation operation name
   * @param cause optional underlying cause
   */
  constructor(message: string, operation: string, cause?: unknown) {
    super(message, AppErrorCode.WORD_API_FAILED, cause);
    this.name = 'WordApiError';
    this.operation = operation;
    Object.setPrototypeOf(this, new.target.prototype);
  }

  /**
   * Factory to create a WordApiError from an OfficeExtension.Error-like object
   * @param err unknown error thrown by the Office API
   * @param context object with `operation` string
   */
  public static fromOfficeError(err: unknown, context: { operation: string }): WordApiError {
    const operation = context.operation;
    if (typeof err === 'object' && err !== null) {
      const e = err as { message?: unknown; debugInfo?: unknown };
      const message = typeof e.message === 'string' ? e.message : 'Unknown Word API error';
      const cause = e.debugInfo ?? err;
      return new WordApiError(message, operation, cause);
    }

    const message = typeof err === 'string' ? err : 'Unknown Word API error';
    return new WordApiError(message, operation, err);
  }
}
